import React from 'react'
import Carousel from 'nuka-carousel'
import { isDesktop } from 'react-device-detect'
import ReactScrollWheelHandler from 'react-scroll-wheel-handler'


export function CarouselWrapper({ slides, slideIndex, slideChange, upHandler, downHandler }) {

  const CarouselComponent = 
    <Carousel
      slideIndex={slideIndex}
      vertical
      swiping
      dragging
      withoutControls
      speed={300}
      afterSlide={slideChange}>
    {slides}
  </Carousel>
  
  if(isDesktop){
    return (
      <ReactScrollWheelHandler 
        upHandler={upHandler}
        downHandler={downHandler}>
          {CarouselComponent}
      </ReactScrollWheelHandler>
    )        
  }

  return CarouselComponent
}
